var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import ActionModal from '../../containers/modals/chatmenu';
const portTranslator = (node) => {
    const { payload: { buttons }, } = node;
    return Object.entries(buttons)
        .sort(([, a], [, b]) => { var _a, _b; return ((_a = a.order) !== null && _a !== void 0 ? _a : 0) - ((_b = b.order) !== null && _b !== void 0 ? _b : 0); })
        .map(([key, { nodeId }]) => ({
        id: uuid(),
        type: 'out',
        label: key,
        connection: nodeId || uuid(),
    }));
};
export class ChatmenuNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        const { node: { payload: { buttons }, }, } = this.props;
        const optionCount = Object.keys(buttons).length;
        const optionText = optionCount === 1 ? 'Option' : 'Options';
        return (_jsx(FlowNode, { color: ChatmenuNode.color, icon: ChatmenuNode.icon, label: ChatmenuNode.label, text: _jsx("span", { children: _jsxs("strong", { children: [optionCount, " ", optionText] }) }), onEdit: this.triggerEdit }));
    }
}
ChatmenuNode.icon = 'channels';
ChatmenuNode.label = 'Menu';
ChatmenuNode.color = flowNodeColor.purple;
ChatmenuNode.translatePayload = formatPortsHelper(portTranslator);
ChatmenuNode.ActionModal = ActionModal;
ChatmenuNode.actionTrigger = { type: FlowNodeTypes.CHAT_MENU };
ChatmenuNode.updateConnection = (node, port, newConnection) => {
    const { payload } = node;
    const buttons = Object.assign({}, payload.buttons);
    if (port.label && buttons[port.label]) {
        buttons[port.label].nodeId = newConnection;
    }
    return Object.assign(Object.assign({}, node), { payload: Object.assign(Object.assign({}, payload), { buttons }) });
};
__decorate([
    boundMethod
], ChatmenuNode.prototype, "triggerEdit", null);
